import Axios from "axios";
import { action, decorate, observable } from "mobx";

export default class ManageConfigZeroDrsStore {
	list_data = [];
	
	// call api to get records
	getList = (payload) => {
		return Axios.post(`locks/zero-drs/list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				this.list_data = data.list ? data.list.data : null;
			}
			return data;
		});
	};

	// Call add api
	EditData = (formdata) => {
		return Axios.post(`locks/zero-drs/update`, formdata)
			.then(({ data }) => {
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};
}

decorate(ManageConfigZeroDrsStore, {
	list_data: observable,
	getList: action,
});